











































































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'OareDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    showSubmit: {
      type: Boolean,
      default: true,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    persistent: {
      type: Boolean,
      default: true,
    },
    submitText: {
      type: String,
      default: 'Submit',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    submitLoading: {
      type: Boolean,
      default: false,
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    cancelDisabled: {
      type: Boolean,
      default: false,
    },
    closeOnSubmit: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 500,
    },
    closeButton: {
      type: Boolean,
      default: false,
    },
    actionTitle: {
      type: String,
      required: false,
    },
    eager: {
      type: Boolean,
      default: false,
    },
    showActionsBar: {
      type: Boolean,
      defaault: false,
    },
    showActionButton: {
      type: Boolean,
      default: false,
    },
    actionButtonText: {
      type: String,
      default: 'Action',
    },
    actionButtonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup({ closeOnSubmit }, { emit }) {
    const submit = () => {
      if (closeOnSubmit) {
        emit('input', false);
      }
      emit('submit');
    };

    return {
      submit,
    };
  },
});
